import React, { FunctionComponent } from 'react';
import { Text } from 'components/chroma';
import { FunnelType } from 'scenes/common/types';
import { addNDaysToDate } from 'scenes/common/helpers/datetime';

const COVER_NOTE_PERIOD = 21;

const coverNoteExpiry = (policyStartDate: string) =>
  addNDaysToDate(policyStartDate, COVER_NOTE_PERIOD);

const productDisplayName = new Map([
  [FunnelType.Home, 'home'],
  [FunnelType.Motor, 'car'],
  [FunnelType.Landlord, 'property'],
]);

type BpayDisclaimerProps = {
  emailAddress: string;
  policyStartDate: string;
  productType: FunnelType;
};

const BpayDisclaimer: FunctionComponent<BpayDisclaimerProps> = ({
  emailAddress,
  policyStartDate,
  productType,
}) => (
  <>
    <Text>
      Selecting BPAY as your payment method will generate an Insurance Cover
      Note that will expire on {coverNoteExpiry(policyStartDate)}.{' '}
    </Text>
    <Text>This will be emailed to {emailAddress} shortly.</Text>
    <Text>
      The Cover Note includes your Certificate of Insurance and BPAY
      instructions.
    </Text>
    <Text>
      All you need to do is pay the amount, before expiry date shown, and you
      will be covered for the 12 month period in your Certificate of Insurance.
    </Text>
    <Text>
      Don’t forget to make your payment several business days before the expiry
      date to allow for processing.{' '}
    </Text>{' '}
    <Text>
      If we don’t receive payment by {coverNoteExpiry(policyStartDate)}, your{' '}
      {productDisplayName.get(productType)} will not be insured from that date.
    </Text>
  </>
);

export default BpayDisclaimer;
